module.exports = __webpack_public_path__ + "static/media/fuel dispenser.303833ed.png";